import { createFeature } from "@ngrx/store";
import { createJobReducer } from "@modules/job/store/create-job.reducer";

export const createJobFeature = createFeature({
  name: 'createJob',
  reducer: createJobReducer,
});
